import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FranchiseProfileInterface } from "../models/franchise/franchise-profile.interface";
import { environment } from "src/environments/environment";
import { Constants } from "../data/constants";
import { SuccessDto } from "../models/success-dto";
import { FranchiseMainDashboardDto } from "../models/franchise/FranchiseMainDashboardDto";
import {
  TopFranchisedResult,
  TopFranchiseRequest,
} from "../models/franchise/topFranchised.interface";
import { RemunerationFilterDto } from "../models/franchise/remunerationFilterDto.interface";
import { PaymentDetails } from "../models/franchise/paymentDetails.interface";
import { FranchisesRemunerationWithResultDto } from "../models/franchise/franchisesRemunerationWithResultDto.interface";
import { CreateFranchiseInterface } from "../models/franchise/createFranchise";
import { LocationPartnersFilterInterface } from "../models/location-partners/locationPartnersFilter.interface";
import { FranchiseResultInterface } from "../models/franchise/franchise-result.interface";
import { LocationPartnerInterface } from "../models/location-partners/locationPartner.interface";
import { LocationPartnersResultInterface } from "../models/location-partners/locationPartnersResult.interface";
import { ComparatorRequestDto } from "../models/franchise/ComparatorRequestDto";
import { ComparatorSummary } from "../models/franchise/ComparatorSummary";

@Injectable({
  providedIn: "root",
})
export class FranchiseService {
  constructor(private http: HttpClient) {}

  getFranchiseInfo(): Observable<FranchiseProfileInterface | null> {
    return this.http.get<FranchiseProfileInterface>(
      `${environment.APP_PORT + Constants.FRANCHISE_ENDPOINT}/infoByToken`
    );
  }

  updateFranchiseProfile(
    profile: FranchiseProfileInterface
  ): Observable<SuccessDto> {
    return this.http.patch<SuccessDto>(
      `${environment.APP_PORT + Constants.FRANCHISE_ENDPOINT}/updateProfile`,
      profile
    );
  }

  getFranchisedCompanyNamesByFranchise(
    companyName: string
  ): Observable<string[]> {
    return this.http.get<string[]>(
      `${
        environment.APP_PORT + Constants.FRANCHISE_ENDPOINT
      }/allFranchised/${companyName}`
    );
  }
  getMainDashboard(
    refreshCache: boolean
  ): Observable<FranchiseMainDashboardDto> {
    return this.http.get<FranchiseMainDashboardDto>(
      `${
        environment.APP_PORT + Constants.FRANCHISE_ENDPOINT
      }/${refreshCache}/main`
    );
  }

  getTopFranchised(
    refreshCache: boolean,
    request: TopFranchiseRequest
  ): Observable<TopFranchisedResult | null> {
    return this.http.post<TopFranchisedResult | null>(
      `${
        environment.APP_PORT + Constants.STATICS_ENDPOINT
      }/top-franchised/refreshCache/${refreshCache}`,
      request
    )
  }
  remunerationDetails(
    filter: RemunerationFilterDto,
    refreshCache : boolean
  ): Observable<FranchisesRemunerationWithResultDto> {
    return this.http.post<FranchisesRemunerationWithResultDto>(
      `${environment.APP_PORT + Constants.FRANCHISE_ENDPOINT}/refreshCache/${refreshCache}/remuneration`,
      filter
    );
  }

  paymentDetails(): Observable<PaymentDetails | null> {
    return this.http.get<PaymentDetails | null>(
      `${environment.APP_PORT + Constants.FRANCHISE_ENDPOINT}/payment`
    );
  }

  getFranchiseList(): Observable<string[]> {
    return this.http.get<string[]>(
      `${
        environment.APP_PORT + Constants.FRANCHISE_ENDPOINT
      }/all-companies-names`
    );
  }
  
  createFranchise(
    createFranchise: CreateFranchiseInterface
  ): Observable<SuccessDto> {
    return this.http.post<SuccessDto>(
      `${environment.APP_PORT + Constants.FRANCHISE_ENDPOINT}`,
      createFranchise
    );
  }

  getAllFranchisesByFilter(
    franchiseFilter: LocationPartnersFilterInterface
  ): Observable<FranchiseResultInterface> {
    return this.http.post<FranchiseResultInterface>(
      `${environment.APP_PORT + Constants.FRANCHISE_ENDPOINT}/filter`,
      franchiseFilter
    );
  }

  getAllFranchisesCompanyNames(): Observable<string[]> {
    return this.http.get<string[]>(
      `${
        environment.APP_PORT + Constants.FRANCHISE_ENDPOINT
      }/all-companies-names`
    );
  }

  getFranchiseInfoByCompanyName(companyName: string): Observable<FranchiseProfileInterface> {
    return this.http.get<FranchiseProfileInterface>(
      `${
        environment.APP_PORT + Constants.FRANCHISE_ENDPOINT
      }/companyName/${companyName}`
    );
  }

  updateFranchiseFullProfile(
    updateFranchise: LocationPartnerInterface | null,
    email: string | null
  ): Observable<SuccessDto> {
    return this.http.patch<SuccessDto>(
      `${
        environment.APP_PORT + Constants.FRANCHISE_ENDPOINT
      }/` + email,
      updateFranchise
    );
  }

  deleteFranchiseAndSomeLocations(franchise: string | null, locations: string[]): Observable<SuccessDto> {
    return this.http.post<SuccessDto>(
      `${environment.APP_PORT + Constants.FRANCHISE_ENDPOINT}/delete/${franchise}`,
      { locationPartnersCompanyNames: locations }
    );
  }

  getFranchisedsByFranchiseCompanyName(companyName: string | null, filter: LocationPartnersFilterInterface ): Observable<LocationPartnersResultInterface | null> {
    return this.http.post<LocationPartnersResultInterface | null>(
      `${environment.APP_PORT + Constants.FRANCHISE_ENDPOINT}/associatedLocations/companyName/${companyName}`,
      filter
    );
  }

  compareLocations(payload: ComparatorRequestDto): Observable<ComparatorSummary[] | null> {
    return this.http.post<ComparatorSummary[] | null>(
      `${environment.APP_PORT + Constants.STATICS_ENDPOINT}/franchise/comparator/date-range`,
      payload
    );
  }
}
